export enum OnTopProductEnum {
  topImmoRankingCategory = 15
}
